export default __webpack_public_path__ + "static/media/Person.5dd06dba.png";